/**
 * 头部导航组件
 * zxw
 * 创建时间：2023-03-07
 * 修改时间：2026-06-29
*/


import {
    MenuUnfoldOutlined,
    MenuFoldOutlined,
    QuestionOutlined,
    LogoutOutlined,
    SettingOutlined,
} from '@ant-design/icons';
import {
    Layout,
    Dropdown,
    Avatar,
    Button,
    message,
    theme,
    Flex,
    Typography,
} from 'antd';
import cookie from 'react-cookies';
import CNF from '../incs/Config';
import { DeleteCookies } from '../incs/FunHelper';
import XNavService from './XNavService';

const { Header } = Layout;
const { Text } = Typography;

const onClick = (e) => {
    if (e.key === '1') {
        window.location.href = CNF.userUrl;
    }
    if (e.key === '2') {
        message.info('正在努力开发中......');
    }
    if (e.key === '3') {
        // 退出登录
        DeleteCookies()
    }
}

const XHeader = (props) => {
    const {
        token: {
            colorPrimary
        },
    } = theme.useToken();

    const items = [
        {
            key: '1',
            label: <Button icon={<SettingOutlined />} style={{ color: colorPrimary, }} color='default' variant='link'>设置</Button>,
        },
        {
            key: '2',
            label: <Button icon={<QuestionOutlined />} style={{ color: colorPrimary, }} color='default' variant='link'>帮助</Button>,
        }, {
            key: '3',
            label: <Button icon={<LogoutOutlined />} style={{ color: colorPrimary, }} color='default' variant='link'>退出</Button>,
        }
    ]
    return (
        <>
            <Header style={{
                padding: 0,
                paddingRight: 20,
            }}>
                <Flex justify='space-between' align='center'>
                    <Button
                        size='small'
                        color='primary'
                        variant='link'
                        icon={props.collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                        onClick={() => props.setCollapsed(!props.collapsed)}
                        style={{ width: 'auto' }}
                    />
                    <Flex justify='flex-end' align='center'>
                        {
                            props.navLists.length > 0 && props.navLists.map((item, index) => {
                                return <Button key={index} color='primary' variant='link' href={item.url} target='_blank' rel='noopener noreferrer' title={item.name}>{item.name}</Button>
                            })
                        }
                        <div style={{ marginLeft: 30 }}>
                            <XNavService
                                setThemeColor={props.setThemeColor}
                                isCompact={props.isCompact}
                                setIsCompact={props.setIsCompact}
                                isDarkMode={props.isDarkMode}
                                setIsDarkMode={props.setIsDarkMode}
                            />
                        </div>
                        <Text style={{ color: colorPrimary, margin: '0 30px' }}>简体中文</Text>
                        <Dropdown menu={{ items, onClick }} styles={{
                            item: { padding: 0 }
                        }}>
                            <Button type='link' style={{ padding: 0 }}>
                                {
                                    cookie.load(CNF.cookies.keyAvatarUrl) ? (
                                        <Avatar
                                            size='middle'
                                            src={cookie.load(CNF.cookies.keyAvatarUrl) ? CNF.ossApi + cookie.load(CNF.cookies.keyAvatarUrl) : ''}
                                        />
                                    ) : (
                                        <Avatar
                                            style={{
                                                verticalAlign: 'middle',
                                                backgroundColor: colorPrimary,
                                            }}
                                            size='middle'
                                        >
                                            {cookie.load(CNF.cookies.keyId) ? cookie.load(CNF.cookies.keyId).substr(0, 1).toUpperCase() : 'U'}
                                        </Avatar>
                                    )
                                }
                            </Button>
                        </Dropdown>
                    </Flex>
                </Flex>
            </Header >
        </>
    )
}

export default XHeader